import Button from '../common/Button';
import ContactCTA from '../common/ContactCTA';

function ServiceDetailPage({ service }) {
  return (
    <>
      <section className="service-detail-hero" aria-labelledby="service-detail-title">
        <div className="container service-detail-hero__inner">
          <div className="service-detail-hero__copy">
            <p className="eyebrow">{service.eyebrow}</p>
            <h1 id="service-detail-title">{service.title}</h1>
            <p>{service.intro}</p>
            <div className="service-detail-hero__actions">
              <Button to="/contact">{service.primaryAction}</Button>
              <Button href="tel:+14374357083" variant="secondary">
                Call (437) 435-7083
              </Button>
            </div>
          </div>
          <div
            className="service-detail-hero__image"
            style={{ '--service-detail-image': `url(${process.env.PUBLIC_URL}${service.image})` }}
            aria-label={`${service.title} image`}
          />
        </div>
      </section>

      <section className="service-detail-section">
        <div className="container service-detail-section__grid">
          <div>
            <p className="eyebrow">Capabilities</p>
            <h2>What we can help with</h2>
          </div>
          <div className="service-detail-list">
            {service.capabilities.map((item) => (
              <article key={item} className="service-detail-list__item">
                <span aria-hidden="true" />
                <p>{item}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="service-detail-section service-detail-section--muted">
        <div className="container service-detail-section__grid">
          <div>
            <p className="eyebrow">Warning Signs</p>
            <h2>When to request a repair review</h2>
          </div>
          <div className="service-detail-list service-detail-list--compact">
            {service.warningSigns.map((item) => (
              <article key={item} className="service-detail-list__item">
                <span aria-hidden="true" />
                <p>{item}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="service-detail-process" aria-labelledby="service-detail-process-title">
        <div className="container">
          <div className="service-detail-process__header">
            <p className="eyebrow">Process</p>
            <h2 id="service-detail-process-title">A direct repair path</h2>
          </div>
          <div className="service-detail-process__steps">
            {service.process.map((step, index) => (
              <article key={step} className="service-detail-process__step">
                <span>{String(index + 1).padStart(2, '0')}</span>
                <p>{step}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="service-detail-faq" aria-labelledby="service-detail-faq-title">
        <div className="container service-detail-faq__inner">
          <div>
            <p className="eyebrow">Service FAQ</p>
            <h2 id="service-detail-faq-title">Common questions</h2>
          </div>
          <div className="service-detail-faq__list">
            {service.faq.map((item) => (
              <article key={item.question} className="service-detail-faq__item">
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}

export default ServiceDetailPage;
